import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'inventarios',
})
export class InventariosPipe implements PipeTransform {

  transform(items: any[], filter: any[]): any {


    if (items) {


      if ((filter['id_partida'] || filter['id_partida'] == 0) && filter['id_partida'] !== '') {


        items = items.filter(function (item) {

          return item.id_partida === filter['id_partida'];

        });

      }

      if (filter['id_produccion'] && filter['id_produccion'] > 0) {

        items = items.filter(function (item) {

          return item.id_produccion === filter['id_produccion'];

        });

      }

      if (filter['id_caducidad'] > 0) {

        let now = new Date();
        let ahora = now.getTime();
        let ahora24 = ahora + 86400000;

        items = items.filter(function (item) {


          if (filter['id_caducidad'] == 1) {

            return item.last_produccion && item.last_produccion.fecha_cad_u > ahora;

          } else if (filter['id_caducidad'] == 2) {

            return item.last_produccion && item.last_produccion.fecha_cad_u > ahora && item.last_produccion.fecha_cad_u < ahora24;

          } else if (filter['id_caducidad'] == 3) {

            return item.last_produccion && item.last_produccion.fecha_cad_u < ahora;

          }


          //return item.last_produccion && item.last_produccion.fecha_cad_u > ahora;


        });
      }

      if (filter['id_familia_top'] && filter['id_familia_top'] > 0) {

        items = items.filter(function (item) {

          return item.id_familia_pricipal == filter['id_familia_top'];

        });
      }



      if (filter['id_familia'] && filter['id_familia'] > 0) {
        items = items.filter((item) => filter['familia_master'] ? item.id_familia_master == filter['id_familia'] : item.id_familia == filter['id_familia']);
      }


      if (filter['activo'] && items) {

        if (filter['ordenar_dir'] == 'desc') {


          if (filter['orden'] != 'orden') {
            return items.sort((a, b) => b[filter['orden']].localeCompare(a[filter['orden']]));
          }
          return items.sort((a, b) => b[filter['orden']] - a[filter['orden']]);

        } else {


          if (filter['orden'] != 'orden') {
            return items.sort((a, b) => a[filter['orden']].localeCompare(b[filter['orden']]));
          }
          return items.sort((a, b) => a[filter['orden']] - b[filter['orden']]);
        }

      } else {

        return items;

      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/inventarios/inventarios.ts